// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/modelForm.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bodyColor: #f1f1f1;
  --mainFont: #6e6b7b;
  --headerFont: #0f7f3d;
  --linkHover: #6659f1;
  --linkActive: linear-gradient(80deg, #0f7f3d, #53ca85);
  --linkshadow: 0 0 6px 0px #0f7f3d;
  --inputshadow: 0px 0px 5px 0px #0f7f3d;
  --borderColor: #eae8f0;
  --darkMaincolor: #151515;
  --darkSecondColor: #242424;
  --darkFont: #d0d2d6;
  --darkborderColor: #38393a;
}

* {
  font-family: "Cairo", serif;
}

body {
  margin: 0;
  font-family: "Cairo", serif;
  font-optical-sizing: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bodyColor) !important;
  color: var(--mainFont) !important;
  overflow-x: hidden;
  direction: rtl;
}
body .MuiFormControlLabel-root {
  margin: 30px 0 -15px;
}
body .p-toast {
  direction: ltr !important;
  z-index: 555555 !important;
}
body .center {
  display: flex;
  justify-content: center;
  align-items: center;
}
body .MuiPagination-ul button {
  background-color: #0f7f3d;
  color: #fff;
}
body .MuiPagination-ul button svg {
  transform: rotate(180deg);
}
body .MuiPagination-ul button.Mui-selected {
  color: #fff;
  background-color: #003516;
  font-weight: bold;
}
body .MuiPagination-ul button:hover {
  background-color: #53ca85;
}
body .Login-loadingSpinner {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.637);
  flex-direction: column;
  z-index: 555555;
}
body .Login-loadingSpinner span {
  color: #fff;
  font-weight: 500;
  font-size: 16px;
}
body button {
  border: none;
  transition: 200ms;
  padding: 7px 20px;
  border-radius: 5px;
}
body .base-MenuButton-root {
  position: relative !important;
}
body .button {
  min-width: 170px;
  height: fit-content;
  margin: 0 10px;
  color: #fff;
  background-color: var(--headerFont);
  border: none;
}
body .button:hover {
  background-color: #0f7f3d;
  box-shadow: var(--inputshadow) !important;
}
body .button:focus {
  background-color: #0f7f3d;
  box-shadow: var(--inputshadow) !important;
}
body input,
body textarea {
  font-size: 12px;
  padding: 8px;
}
body textarea:focus,
body input:focus,
body .form-select:focus {
  border: 1px solid #0f7f3d !important;
  box-shadow: var(--inputshadow) !important;
}
body textarea {
  resize: none;
}
body .dropdown button {
  background-color: rgb(241, 241, 241);
  color: var(--headerFont);
  border: none;
}
body .dropdown button:focus,
body .dropdown button:hover {
  box-shadow: none;
  background-color: rgba(241, 241, 241, 0.5137254902) !important;
  color: var(--headerFont);
}
body .dropdown .dropdown-item {
  color: #000;
  text-align: right !important;
}
body .dropdown .dropdown-item a {
  color: #000;
  width: 100%;
  display: block;
}
body .dropdown .dropdown-item svg {
  color: var(--mainFont);
  margin: 0 10px;
}
body .dropdown .dropdown-item:hover {
  background-color: #eaeaf0;
  color: #0f7f3d;
}
body .dropdown .dropdown-item:hover svg {
  color: #0f7f3d;
}
body .dropdown-toggle::after {
  display: none !important;
}
body .dropdown-menu {
  border: none;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}
body .items {
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--borderColor);
  background-color: #fff;
  position: relative;
  min-height: 80vh;
  padding-bottom: 30px;
}
body .items .loadingSpinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
}
body .items .controls {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
body .items .controls form {
  gap: 10px;
}
body .items .controls a {
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 5px;
  text-align: center;
  transition: 200ms;
  color: #fff;
}
body .items .controls input {
  max-width: 300px;
  font-size: 15px;
}
body .items .items-container {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (max-width: 668px) {
  body .items .controls {
    flex-direction: column;
    padding: 15px;
  }
  body .items .controls div {
    margin-top: 10px;
    display: flex;
  }
  body .items .controls div button {
    flex-grow: 1;
  }
  body .items .controls input {
    max-width: 100% !important;
  }
}

.dark {
  background-color: var(--darkMaincolor) !important;
}
.dark .items {
  background-color: var(--darkSecondColor);
  border: 1px solid var(--darkborderColor);
}
.dark .items .filters h6,
.dark .items .filters span {
  color: var(--darkFont);
}
.dark .items select {
  background-color: var(--darkSecondColor);
  border: 1px solid var(--darkborderColor);
  color: var(--darkFont);
}
.dark .items .controls input,
.dark .items .controls select {
  background-color: var(--darkSecondColor) !important;
  border: 1px solid var(--darkborderColor);
  color: var(--darkFont);
}
.dark .dropdown button {
  background-color: rgba(21, 21, 21, 0.4392156863);
}
.dark .dropdown button:focus,
.dark .dropdown button:hover {
  background-color: rgba(21, 21, 21, 0.4392156863) !important;
}
.dark .dropdown .dropdown-menu {
  background-color: var(--darkSecondColor) !important;
  border: 1px solid var(--darkSecondColor);
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);
}
.dark .dropdown .dropdown-item {
  background-color: var(--darkSecondColor);
  color: var(--darkFont);
  text-align: right !important;
}
.dark .dropdown .dropdown-item a,
.dark .dropdown .dropdown-item svg {
  color: var(--darkFont) !important;
}
.dark .dropdown .dropdown-item:hover {
  background-color: rgba(21, 21, 21, 0.4392156863);
}
.dark input::placeholder {
  color: rgb(146, 146, 146);
}
.dark input,
.dark textarea {
  background-color: var(--darkSecondColor);
  border: 1px solid var(--darkborderColor);
  color: var(--darkFont);
}
.dark input:focus,
.dark textarea:focus {
  background-color: var(--darkSecondColor);
  color: var(--darkFont);
}

.rtl {
  direction: rtl;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAGA;EACE,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,sDAAA;EACA,iCAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mBAAA;EACA,0BAAA;AACF;;AACA;EACE,2BAAA;AAEF;;AAAA;EACE,SAAA;EACA,2BAAA;EACA,yBAAA;EACA,mCAAA;EACA,kCAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;AAGF;AAFE;EACE,oBAAA;AAIJ;AAFE;EACE,yBAAA;EACA,0BAAA;AAIJ;AAFE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAIJ;AADI;EACE,yBAAA;EACA,WAAA;AAGN;AAFM;EACE,yBAAA;AAIR;AADI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAGN;AADI;EACE,yBAAA;AAGN;AAAE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,sCAAA;EACA,sBAAA;EACA,eAAA;AAEJ;AADI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAGN;AAAE;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAEJ;AAAE;EACE,6BAAA;AAEJ;AAAE;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,mCAAA;EACA,YAAA;AAEJ;AAAE;EACE,yBAAA;EACA,yCAAA;AAEJ;AAAE;EACE,yBAAA;EACA,yCAAA;AAEJ;AAAE;;EAEE,eAAA;EACA,YAAA;AAEJ;AAAE;;;EAGE,oCAAA;EACA,yCAAA;AAEJ;AAAE;EACE,YAAA;AAEJ;AACI;EACE,oCAAA;EACA,wBAAA;EACA,YAAA;AACN;AACI;;EAEE,gBAAA;EACA,8DAAA;EACA,wBAAA;AACN;AAEI;EACE,WAAA;EACA,4BAAA;AAAN;AACM;EACE,WAAA;EACA,WAAA;EACA,cAAA;AACR;AACM;EACE,sBAAA;EACA,cAAA;AACR;AAEI;EACE,yBAAA;EACA,cAAA;AAAN;AACM;EACE,cAAA;AACR;AAGE;EACE,wBAAA;AADJ;AAGE;EACE,YAAA;EACA,6CAAA;AADJ;AAGE;EACE,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AADJ;AAEI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;AAAN;AAEI;EACE,aAAA;EACA,8BAAA;EACA,aAAA;AAAN;AACM;EACE,SAAA;AACR;AACM;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AACR;AACM;EACE,gBAAA;EACA,eAAA;AACR;AAEI;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAAN;AAGE;EAEI;IACE,sBAAA;IACA,aAAA;EAFN;EAGM;IACE,gBAAA;IACA,aAAA;EADR;EAEQ;IACE,YAAA;EAAV;EAGM;IACE,0BAAA;EADR;AACF;;AAMA;EACE,iDAAA;AAHF;AAIE;EACE,wCAAA;EACA,wCAAA;AAFJ;AAIM;;EAEE,sBAAA;AAFR;AAKI;EACE,wCAAA;EACA,wCAAA;EACA,sBAAA;AAHN;AAMM;;EAEE,mDAAA;EACA,wCAAA;EACA,sBAAA;AAJR;AASI;EACE,gDAAA;AAPN;AASI;;EAEE,2DAAA;AAPN;AASI;EACE,mDAAA;EACA,wCAAA;EACA,4CAAA;AAPN;AASI;EACE,wCAAA;EACA,sBAAA;EACA,4BAAA;AAPN;AAQM;;EAEE,iCAAA;AANR;AASI;EACE,gDAAA;AAPN;AAUE;EACE,yBAAA;AARJ;AAUE;;EAEE,wCAAA;EACA,wCAAA;EACA,sBAAA;AARJ;AAUE;;EAEE,wCAAA;EACA,sBAAA;AARJ;;AAWA;EACE,cAAA;AARF;;AAUA;EACE,+EAAA;AAPF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap\");\n@import \"bootstrap/dist/css/bootstrap.min.css\";\n@import url(assets/styles/modelForm.scss);\n:root {\n  --bodyColor: #f1f1f1;\n  --mainFont: #6e6b7b;\n  --headerFont: #0f7f3d;\n  --linkHover: #6659f1;\n  --linkActive: linear-gradient(80deg, #0f7f3d, #53ca85);\n  --linkshadow: 0 0 6px 0px #0f7f3d;\n  --inputshadow: 0px 0px 5px 0px #0f7f3d;\n  --borderColor: #eae8f0;\n  --darkMaincolor: #151515;\n  --darkSecondColor: #242424;\n  --darkFont: #d0d2d6;\n  --darkborderColor: #38393a;\n}\n* {\n  font-family: \"Cairo\", serif;\n}\nbody {\n  margin: 0;\n  font-family: \"Cairo\", serif;\n  font-optical-sizing: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bodyColor) !important;\n  color: var(--mainFont) !important;\n  overflow-x: hidden;\n  direction: rtl;\n  .MuiFormControlLabel-root {\n    margin: 30px 0 -15px;\n  }\n  .p-toast {\n    direction: ltr !important;\n    z-index: 555555 !important;\n  }\n  .center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .MuiPagination-ul {\n    button {\n      background-color: #0f7f3d;\n      color: #fff;\n      svg {\n        transform: rotate(180deg);\n      }\n    }\n    button.Mui-selected {\n      color: #fff;\n      background-color: #003516;\n      font-weight: bold;\n    }\n    button:hover {\n      background-color: #53ca85;\n    }\n  }\n  .Login-loadingSpinner {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.637);\n    flex-direction: column;\n    z-index: 555555;\n    span {\n      color: #fff;\n      font-weight: 500;\n      font-size: 16px;\n    }\n  }\n  button {\n    border: none;\n    transition: 200ms;\n    padding: 7px 20px;\n    border-radius: 5px;\n  }\n  .base-MenuButton-root {\n    position: relative !important;\n  }\n  .button {\n    min-width: 170px;\n    height: fit-content;\n    margin: 0 10px;\n    color: #fff;\n    background-color: var(--headerFont);\n    border: none;\n  }\n  .button:hover {\n    background-color: #0f7f3d;\n    box-shadow: var(--inputshadow) !important ;\n  }\n  .button:focus {\n    background-color: #0f7f3d;\n    box-shadow: var(--inputshadow) !important ;\n  }\n  input,\n  textarea {\n    font-size: 12px;\n    padding: 8px;\n  }\n  textarea:focus,\n  input:focus,\n  .form-select:focus {\n    border: 1px solid #0f7f3d !important;\n    box-shadow: var(--inputshadow) !important ;\n  }\n  textarea {\n    resize: none;\n  }\n  .dropdown {\n    button {\n      background-color: rgb(241 241 241);\n      color: var(--headerFont);\n      border: none;\n    }\n    button:focus,\n    button:hover {\n      box-shadow: none;\n      background-color: #f1f1f183 !important;\n      color: var(--headerFont);\n    }\n\n    .dropdown-item {\n      color: #000;\n      text-align: right !important;\n      a {\n        color: #000;\n        width: 100%;\n        display: block;\n      }\n      svg {\n        color: var(--mainFont);\n        margin: 0 10px;\n      }\n    }\n    .dropdown-item:hover {\n      background-color: #eaeaf0;\n      color: #0f7f3d;\n      svg {\n        color: #0f7f3d;\n      }\n    }\n  }\n  .dropdown-toggle::after {\n    display: none !important;\n  }\n  .dropdown-menu {\n    border: none;\n    box-shadow: 0 5px 10px rgb(30 32 37 / 12%);\n  }\n  .items {\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid var(--borderColor);\n    background-color: #fff;\n    position: relative;\n    min-height: 80vh;\n    padding-bottom: 30px;\n    .loadingSpinner {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n    .controls {\n      display: flex;\n      justify-content: space-between;\n      padding: 20px;\n      form {\n        gap: 10px;\n      }\n      a {\n        text-decoration: none;\n        padding: 5px 10px;\n        border-radius: 5px;\n        text-align: center;\n        transition: 200ms;\n        color: #fff;\n      }\n      input {\n        max-width: 300px;\n        font-size: 15px;\n      }\n    }\n    .items-container {\n      width: 100%;\n      height: fit-content;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n  @media (max-width: 668px) {\n    .items {\n      .controls {\n        flex-direction: column;\n        padding: 15px;\n        div {\n          margin-top: 10px;\n          display: flex;\n          button {\n            flex-grow: 1;\n          }\n        }\n        input {\n          max-width: 100% !important;\n        }\n      }\n    }\n  }\n}\n.dark {\n  background-color: var(--darkMaincolor) !important;\n  .items {\n    background-color: var(--darkSecondColor);\n    border: 1px solid var(--darkborderColor);\n    .filters {\n      h6,\n      span {\n        color: var(--darkFont);\n      }\n    }\n    select {\n      background-color: var(--darkSecondColor);\n      border: 1px solid var(--darkborderColor);\n      color: var(--darkFont);\n    }\n    .controls {\n      input,\n      select {\n        background-color: var(--darkSecondColor) !important;\n        border: 1px solid var(--darkborderColor);\n        color: var(--darkFont);\n      }\n    }\n  }\n  .dropdown {\n    button {\n      background-color: #15151570;\n    }\n    button:focus,\n    button:hover {\n      background-color: #15151570 !important;\n    }\n    .dropdown-menu {\n      background-color: var(--darkSecondColor) !important;\n      border: 1px solid var(--darkSecondColor);\n      box-shadow: 0 4px 24px 0 rgb(0 0 0 / 24%);\n    }\n    .dropdown-item {\n      background-color: var(--darkSecondColor);\n      color: var(--darkFont);\n      text-align: right !important;\n      a,\n      svg {\n        color: var(--darkFont) !important;\n      }\n    }\n    .dropdown-item:hover {\n      background-color: #15151570;\n    }\n  }\n  input::placeholder {\n    color: rgb(146, 146, 146);\n  }\n  input,\n  textarea {\n    background-color: var(--darkSecondColor);\n    border: 1px solid var(--darkborderColor);\n    color: var(--darkFont);\n  }\n  input:focus,\n  textarea:focus {\n    background-color: var(--darkSecondColor);\n    color: var(--darkFont);\n  }\n}\n.rtl {\n  direction: rtl;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
